import * as fromResults from '../reducers/search-results.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'search';

export interface LandingState {
  results: fromResults.SearchResultsState;
}

export const reducers: ActionReducerMap<LandingState> = {
  results: fromResults.SearchResultsReducer,
};

export const getSearchState = createFeatureSelector<LandingState>(featureKey);

export const metaReducers: MetaReducer<LandingState>[] = !environment.production ? [] : [];
